import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-705f1e12"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Home ")
const _hoisted_2 = {
  key: 0,
  class: "home_icon"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://image.kilimall.com/kenya/new_wap/logo/icon_48.png" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Categories")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Message")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Cart")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Account")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!

  return (_openBlock(), _createBlock(_component_van_tabbar, {
    modelValue: $props.active,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($props.active) = $event)),
    class: "position_box"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_tabbar_item, {
        class: "home_item",
        replace: "",
        to: "/home",
        icon: $props.active==0?'wap-home' : 'wap-home-o'
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          ($props.active == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["icon"]),
      _createVNode(_component_van_tabbar_item, {
        replace: "",
        to: "/category",
        icon: "bars"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_van_tabbar_item, {
        replace: "",
        to: "/message",
        icon: $props.active==2?'chat':'chat-o'
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["icon"]),
      _createVNode(_component_van_tabbar_item, {
        replace: "",
        to: "/cart",
        icon: $props.active==3?'shopping-cart':'shopping-cart-o',
        badge: $setup.$store.getCart()?$setup.$store.getCart().length:0
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["icon", "badge"]),
      _createVNode(_component_van_tabbar_item, {
        replace: "",
        to: "/usercenter",
        icon: $props.active==4?'manager':'contact'
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["icon"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}